import { FunctionComponent } from 'react'
import { AppButton } from '@/shared/ui'

export declare type ButtonTypes = 'default' | 'primary'

export type CustomButtonProps = {
  buttonText?: string
  action?: () => void
  type?: ButtonTypes
  disabled?: boolean
  className?: string
  id?: string
  icon?: React.ReactNode
}

export const CustomButton: FunctionComponent<CustomButtonProps> = ({
  buttonText = 'Cancelar',
  action = () => {},
  type = 'default',
  disabled = false,
  id,
  className = '',
  icon
}: CustomButtonProps): JSX.Element => {
  return (
    <div data-testid='gungnir-cb' className={`gungnir-cb ${className}`}>
      <AppButton onClick={action} className={`gungnir-cb-button ${type}`} disabled={disabled} icon={icon} id={id}>
        {buttonText}
      </AppButton>
    </div>
  )
}
